import React, { type FC, type PropsWithChildren, type ReactNode, useRef, useState } from 'react'

import { useIntervalEffect } from '../../Interval'

type Props = Readonly<{
    /**
     * In milliseconds
     */
    delay: number
}>

/**
 * This component allows for delayed rendering
 * Good for components that need a lot of re-rendering
 * This forces the render to happen at most, once every {param0.delay}ms
 *
 * @param props
 */
export const Delay: FC<PropsWithChildren<Props>> = ({ delay, children }) => {
    const updatedChildrenRef = useRef<ReactNode>()
    updatedChildrenRef.current = children

    const [renderedChildren, setRenderedChildren] = useState(() => updatedChildrenRef.current)

    /**
     * At the given refresh rate
     * Update the children
     */
    useIntervalEffect(() => {
        if (updatedChildrenRef.current !== renderedChildren) {
            setRenderedChildren(updatedChildrenRef.current)
        }
    }, delay)

    return <>{renderedChildren}</>
}
